import { z } from 'zod';
export const INTRODUCTION_LINK_PARTIES = ['owner', 'client', 'share'];
export const introductionLinkPartySchema = z.enum(INTRODUCTION_LINK_PARTIES);
/** The broker's own term for how long the brokerage stands after an introduction. Empty means no term. */
export const introductionLinksSchema = z.object({
    periodMonths: z.number().int().min(1).max(36).nullable().optional(),
});
//# sourceMappingURL=introduction-link.js.map